import { Cookie } from './cookie';
import { formData } from './utils';
import { initForm } from './form';

export function modal() {
    const $page  = $('#page');
    const cookie = new Cookie;

    function Modal(modalName, modalType = 'modal', options = {}) {
        const obj = this;
        const $container = document.querySelector(`[data-modal="${modalName}"]`);

        // нет модалки
        if ($container === null) {
            return false;
        }

        options = Object.assign({
            'title': 'Ваша заявка<br> успешно отправлена!',
            'description': 'С вами свяжутся в ближайшее время.',
        }, options);

        for (let field in options) {
            let $field = $container.querySelector('[data-field=' + field + ']');
            if ($field) $field.innerHTML = options[field];
        }

        this.$container = $container;

        // открытие модалки
        this.open = function() {
            $container.classList.add('is-active');

            setTimeout(function () {
                $container.classList.add('is-visible');

                if (modalType === 'modal') {
                    document.body.style.setProperty('padding-right', window.innerWidth - document.body.clientWidth + 'px');

                    document.body.style.overflowY = 'hidden';
                    document.documentElement.style.overflowY = 'hidden';
                }
            }, 300);
        }

        // закрытие модалки
        this.close = function() {
            $container.classList.remove('is-visible');

            setTimeout(function () {
                $container.classList.remove('is-active');

                if (modalType === 'modal') {
                    document.body.style.removeProperty('padding-right');

                    document.body.style.overflowY = '';
                    document.documentElement.style.overflowY = '';
                }
            }, 300);
        }

        // крестик закрытия модалки
        $container.addEventListener('click', function (event) {
            if (event.target.classList.contains('js-modalClose')) {
                obj.close()
            }
        });
    }

    // загрузка модалок по ajax
    function load_ajax_modal(modalName, options = {})
    {
        // выбор города и поиск
        if (modalName === 'take-city') {
            fetch('/handler/get_cities', {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
            .then(response => response.json())
            .then(r => {
                if (r.status != 'ok') {
                    return;
                }

                $page.append(r.render);

                initTakeCityModal(r);

                (new Modal(modalName)).open();
            });
        }

        // показываем модалку вы из города Самара
        if (modalName === 'get-city') {
            fetch('/handler/ajax_city_modal', {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
            .then(response => response.json())
            .then(r => {
                if (r.status != 'ok') {
                    return;
                }

                $page.append(r.render);

                // открываем модалку
                const getCityModal = new Modal(modalName, 'popup');
                      getCityModal.open();

                const $acceptButton = getCityModal.$container.querySelector('.js-acceptButton');
                const $declineButton = getCityModal.$container.querySelector('.js-declineButton');

                // переход на предложенный поддомен
                $acceptButton.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    cookie.set('isCityCorrect', 1, {domain: '.caps-group.ru'});
                    location.href = $acceptButton.dataset.url + location.pathname;
                });

                // показываем модалку выбора города
                $declineButton.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    getCityModal.close();

                    cookie.set('isCityCorrect', 1, {domain: '.caps-group.ru'});
                    return load_ajax_modal('take-city');
                });
            });
        }

        // оставить резюме
        if (modalName === 'vacancy') {
            fetch('/handler/get_vacancy', {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
            .then(response => response.json())
            .then(r => {
                if (r.status != 'ok') {
                    return;
                }

                $page.append(r.render);

                (new Modal(modalName)).open();

                initForm(document.querySelector('[data-modal="vacancy"] form'));

                document.querySelectorAll('.input__file').forEach(input => {
                    let label = input.nextElementSibling,
                        labelVal = label.querySelector('.input__file-button-text').innerText;

                    input.addEventListener('change', function (e) {
                        let countFiles = '';
                        if (this.files && this.files.length >= 1)
                            countFiles = this.files.length;

                        if (countFiles)
                            label.querySelector('.input__file-button-text').innerText = 'Файл добавлен';
                        else
                            label.querySelector('.input__file-button-text').innerText = labelVal;
                    });
                });
            });
        }

        const $modal = document.querySelector(`[data-modal="${modalName}"]`);
        if ($modal !== null) {
            return (new Modal(modalName, 'modal', options)).open();
        }
    }

    /**
     * TODO Поиск по городу в модалке городов
     */
    function initTakeCityModal(request)
    {
        const $modal    = document.querySelector(`[data-modal="take-city"]`);
        const $input    = $modal.querySelector('.js-searchInput');
        const $dropdown = $modal.querySelector('.js-dropdownWrapper');
        let abortController;

        $input.addEventListener('input', doSearch);

        $modal.addEventListener('click', function(e) {
            const $item = e.target;

            if ($item.classList.contains('js-selectCity')) location.href = $item.dataset.url + location.pathname;
        });

        function doSearch() {
            const query = $input.value;

            if (query.length >= 3) {
                // останавливаем запрос, если он был
                if (abortController) {
                    abortController.abort();
                }

                abortController = new AbortController();

                // отправляем запрос к серверу
            fetch('/handler/search_city', {
                    method: 'POST',
                    headers:
                    {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    signal: abortController.signal,
                    body: formData({query})
                })
                .then(response => response.json())
                .then(r => {
                    if (r.status === 'ok') {
                        if (r.render.length === 0) {
                            $dropdown.classList.add('is-hidden');
                            return;
                        }

                        $dropdown.innerHTML = '';

                        const $div = document.createElement('div');
                              $div.innerHTML = r.render;
                        $dropdown.appendChild($div);

                        $dropdown.classList.remove('is-hidden');
                    }
                });
            } else {
                $dropdown.classList.add('is-hidden');
            }
        }
    }

    function openModal(modalName, options = {})
    {
        const modalWindow = document.querySelector(`[data-modal="${modalName}"]`);

        // нет модалки - грузим ее по ajax
        if (modalWindow === null) {
            return load_ajax_modal(modalName);
        }

        (new Modal(modalName, 'modal', options)).open();
    }

    // инициализации клика по кнопкам открытия модалок
    document.querySelectorAll('[data-modalbtn]').forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault;

            openModal(item.dataset.modalbtn);
        });
    });

    window.openModal = openModal;

    $(document).ready(function() {
        if (cookie.get('isCityCorrect')) {
            return false
        }

        // грузим модалку вы из города
        load_ajax_modal('get-city');
    });
}

